import { Search } from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Collapse, Divider, InputAdornment } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { ILayoutFields, ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';
import { NUMBER_REGEX } from 'modules/common/regex';
import { PAYMENT_STATUS } from 'modules/common/apiConstants';

export const STATUS_ENCOUNTER_BILL_OPTIONS = [PAYMENT_STATUS.PAID, PAYMENT_STATUS.UNPAID];

export const fieldSchema: ISchemaFields = ({ valuesField, formProps }) => {
  const { intl, clearParams, state, setState } = formProps || {};
  return {
    mobilePhone: {
      type: 'text-field',
      placeholder: intl.formatMessage({ id: 'searchByTel' }),
      InputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <Search color="inherit" />
          </InputAdornment>
        ),
      },
      showClearBtn: true,
      register: { pattern: { value: NUMBER_REGEX, message: intl.formatMessage({ id: 'telephoneInvalid' }) } },
      propsWrapper: { xs: true },
    },
    paymentStatus: {
      type: 'select',
      hasAllOptions: true,
      label: intl.formatMessage({ id: 'cashier.paymentStatus' }),
      multiple: true,
      options: STATUS_ENCOUNTER_BILL_OPTIONS,
      propsWrapper: { xs: 2.4, xl: true },
    },
    patientName: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'patientName' }),
      placeholder: intl.formatMessage({ id: 'enterPatientName' }),
      noHelperText: true,
      propsWrapper: { xs: 2.4, xl: true },
    },
    patientCode: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'patientCode' }),
      placeholder: intl.formatMessage({ id: 'enterPatientCode' }),
      propsWrapper: { xs: 2.4, xl: true },
    },
    yearOfBirth: {
      type: 'datePicker',
      placeholder: intl.formatMessage({ id: 'enterBirthYear' }),
      label: intl.formatMessage({ id: 'birthYear' }),
      noHelperText: true,
      propsWrapper: { xs: 2.4, xl: true },
      disableFuture: true,
      views: ['year'],
      inputFormat: 'yyyy',
      formatDate: 'yyyy',
      mask: '____',
    },
    fromDate: {
      type: 'datePicker',
      placeholder: intl.formatMessage({ id: 'birthdayForm' }),
      label: intl.formatMessage({ id: 'encounterDateFrom' }),
      noHelperText: true,
      propsWrapper: { xs: 2.4, xl: true, paddingBottom: 1 },
      autoOk: true,
      maxDate: valuesField.toDate ? moment(valuesField.toDate).toDate() : null,
      register: {
        validate: (value) => {
          return value && moment(value).isAfter(valuesField?.toDate)
            ? intl.formatMessage({ id: 'validation.invalidDate' })
            : true;
        },
      },
      required: false,
    },
    toDate: {
      type: 'datePicker',
      placeholder: intl.formatMessage({ id: 'birthdayForm' }),
      label: intl.formatMessage({ id: 'encounterDateTo' }),
      noHelperText: true,
      propsWrapper: { xs: 2.4, xl: true },
      autoOk: true,
      minDate: valuesField.fromDate ? moment(valuesField.fromDate).toDate() : null,
      register: {
        validate: (value) => {
          return value && moment(value).isBefore(valuesField?.fromDate)
            ? intl.formatMessage({ id: 'validation.invalidDate' })
            : true;
        },
      },
      required: false,
    },
    search: {
      type: 'submitButton',
      color: 'inherit',
      label: intl.formatMessage({ id: 'search' }),
      propsWrapper: { xs: undefined },
    },
    expand: {
      type: 'button',
      endIcon: (
        <ExpandLessIcon
          style={{
            transition: '0.2s all',
            transform: state?.expand ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
        />
      ),
      color: 'primary',
      variant: 'text',
      onClick: () => setState({ expand: !state.expand }),
      label: intl.formatMessage({ id: 'advance' }),
      propsWrapper: { xs: undefined },
    },
    reset: {
      type: 'button',
      onClick: () => clearParams && clearParams(),
      color: 'inherit',
      label: intl.formatMessage({ id: 'reset' }),
      propsWrapper: { xs: undefined },
      style: { minWidth: 120, marginTop: 20 },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'layout',
      propsGridContainer: { spacing: 1 },
      fields: ['mobilePhone', 'search', 'expand'],
    },
    {
      id: 'expand',
      fields: ['paymentStatus', 'patientName', 'patientCode', 'yearOfDOB', 'fromDate', 'toDate', 'reset'],
    },

    { id: 'submit', fields: ['save'] },
  ];
};

const LayoutSchema: ILayoutFields = (props) => {
  const { listElement, formProps } = props;
  const { state } = formProps;
  return (
    <>
      <Box display="flex">
        <Box flex={1.5}>{formProps?.pagin}</Box>
        <Box flex={1}>{listElement[0]}</Box>
      </Box>
      <Collapse in={state?.expand} style={{ marginTop: 16 }}>
        {listElement[1]}
        <Divider style={{ marginBottom: 16 }} />
      </Collapse>
    </>
  );
};

export const schemaFilterEncounterForm: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
  layout: LayoutSchema,
};
